<div class="login-page jhm-page sign-up-page">
  <div class="logo-and-name">
    <img class="logo" src="./assets/images/bird.svg">
    <div class="name">
      <img class="jail" src="./assets/images/jail.svg">
      <img class="house" src="./assets/images/house.svg">
      <img class="mail" src="./assets/images/mail.svg">
    </div>
  </div>
@if (pageInitialized) 
{
  @if (!emailSent) {
    <div class="sign-up-box login-box">
      <a [routerLink]="['/login']" class="jhm-icon-button transparent ls-box-back"><i class="fa-regular fa-arrow-left"></i></a>
      <div class="ls-box-header">
        <div class="title">Register - New User</div>
        <div class="welcome">Please enter your details below.</div>
      </div>
      <div class="ls-box-body">
        @if (warningMessage) {
          <div class="notice error">
            <i class="fa-solid fa-hexagon-exclamation notice-lead"></i>
            {{warningMessage}}
            <button class="jhm-icon-button transparent"><i class="fa-regular fa-times" (click)="warningMessage = null"></i></button>
          </div>
        }
        <div class="form-section grouped">
          <div class="form-item">
            <div class="input-title">First Name</div>
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="firstName" id="first-name" name="firstName" placeholder="First Name">
            </mat-form-field>
          </div>
          <div class="form-item">
            <div class="input-title">Last Name</div>
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="lastName" id="last-name" name="lastName" placeholder="Last Name">
            </mat-form-field>
          </div>
        </div>
        <div class="form-section">
          <div class="form-item">
            <div class="input-title">Email</div>
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="email" id="email" name="email" placeholder="Email">
            </mat-form-field>
          </div>
        </div>
        <div class="form-section">
          <div class="form-item">
            <div class="input-title">Password</div>
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="password" type="password" id="password" name="password" placeholder="Password">
            </mat-form-field>
          </div>
        </div>
        <div class="form-section">
          <div class="form-item">
            <div class="input-title">Confirm Password</div>
            <mat-form-field appearance="outline">
              <input matInput [(ngModel)]="confirmPassword" type="password" id="confirm-password" name="confirmPassword" placeholder="Confirm Password">
            </mat-form-field>
          </div>
        </div>
        <div class="form-section">
          <div class="form-item">
            <div class="input-title">Are you registering as an Attorney?</div>
				<mat-radio-group [(ngModel)]="isAttorney" [ngModelOptions]="{standalone: true}" class="radio-container">
					<mat-radio-button [value]="true">Yes</mat-radio-button>
					<mat-radio-button [value]="false">No</mat-radio-button>
				</mat-radio-group>
          </div>
        </div>
		@if (isAttorney) {
			<div class="form-section">
				<div class="form-item">
				  <div class="input-title">State of Practice</div>
                  <mat-form-field class="time-select">
                    <mat-select [(ngModel)]="selectedState">
                      @for (state of stateOptions; track state) {
                        <mat-option value="state.key">{{state.value}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
				</div>
			  </div>
			  <div class="form-section">
				<div class="form-item">
				  <div class="input-title">Graduating Law School</div>
				  <mat-form-field appearance="outline">
					<input matInput [(ngModel)]="lawSchoolName" id="law-school" name="law-school" placeholder="School Name...">
				  </mat-form-field>
				</div>
			  </div>
			  <div class="form-section">
				<div class="form-item">
				  <div class="input-title">Bar Number</div>
				  <mat-form-field appearance="outline">
					<input matInput [(ngModel)]="barNumber" id="bar-number" name="bar-number" placeholder="Bar Number...">
				  </mat-form-field>
				</div>
			  </div>
		}
        <hr class="form-divider" />
      </div>
      <div class="ls-box-footer">
        <div class="form-section">
          <div class="form-item">
            <button class="jhm-button primary" (click)="sendSignUpEmail()">Sign Up</button>
          </div>
        </div>
        <div class="form-section">
          <div class="form-item">Already have an account? <a [routerLink]="['/login']">Log In</a>.</div>
        </div>
      </div>
    </div>
  }

  @if (emailSent) {
	<div class="email-sent-message">
		@if (isAttorney) {
			<div class="login-box">
			  <div class="ls-box-header">
				<div class="title">We'll be in touch!</div>
				<div class="welcome"><span class="highlight">We'll contact you soon </span>to verify your credentials as a practicing attorney</div>
			  </div>
			  <div class="ls-box-body">
				<hr class="form-divider" />
			  </div>
			  <div class="ls-box-footer">
				<div class="form-section">
				  <div class="form-item">
					<button class="jhm-button primary" (click)="resendEmail()">I don't see it. Send it again.</button>
				  </div>
				</div>
				<div class="form-section">
				  <div class="form-item">Already have an account? <a [routerLink]="['/login']">Log In</a>.</div>
				</div>
			  </div>
			</div>
		}
        @else {
            <div class="login-box">
                <div class="ls-box-header">
                    <div class="title">Check your email.</div>
                    <div class="welcome">We sent an email to {{email?email:"you"}}. Click the link within the email to finish setting up your account.</div>
                </div>
                <div class="ls-box-body">
                    <hr class="form-divider" />
                </div>
                <div class="ls-box-footer">
                    <div class="form-section">
                      @if (resendErrorMessage) 
                      {
                        <div class="notice error">
                          {{resendErrorMessage}}
                        </div>
                      }
                      @if (resendSuccessMessage) 
                      {
                        <div class="notice info">
                          {{resendSuccessMessage}}
                        </div>
                      }
                      
                      <div class="form-item">
                          <button class="jhm-button primary" (click)="resendEmail()">I don't see it. Send it again.</button>
                      </div>
                    </div>
                    <div class="form-section">
                    <div class="form-item">Already have an account? <a [routerLink]="['/login']">Log In</a>.</div>
                    </div>
                </div>
            </div>
        }
  </div>
  }
}
</div>